// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cnLF","colBig":"styles_colBig__bTl7G","colSmall":"styles_colSmall__3Mbew"};